export const MATOMO_EVENT_CATEGORIES = {
  FOODLEAP_ENGAGEMENT: 'Foodleap Engagement',
  BECI_ENGAGEMENT: 'BECI Engagement',
  GLOBAL_SEARCH: 'GlobalSearch',
  NO_PERMISSIONS: 'No Permissions',
  ACTOR_LETS_CHAT: 'ActorLetsChat',
  ACTOR_GET_IN_TOUCH: 'ActorGetInTouch',
  ACTOR_SEND_EMAIL: 'ActorSendEmail',
  ACTOR_PHONE_NUMBER: 'ActorPhoneNumber',
  INTERACTIONS: 'Interactions',
  ACTOR_CLAIM: 'Actor claim',
  ANNOUNCEMENT_COMMENT: 'Announcement comment',
  ANNOUNCEMENT_LIKE: 'Announcement like',
  ANNOUNCEMENT_PIN: 'Announcement pin',
  HIGHLIGHTED_SPOTTING_AREA: 'Highlighted Spotting Area',
  ONBOARDING: 'Onboarding',
  SPOTTING_AREA_ACTOR_SUGGESTIONS: 'Spotting Area Actor Suggestions',
  KNOWLEDGE_BASE: 'Knowledge Base',
  PERSONAL_HOME: 'Personal Home',
  TRACTION_TIPS: 'Traction Tips',
  ACTOR_REQUIRED_MODAL: 'Actor Required Modal',
  LINK_PREVIEW: 'Link preview',
  COMMUNITY_MANAGEMENT: 'Community Management',
}

export const MATOMO_EVENT_ACTIONS = {
  SCROLL_DEPTH: 'Scroll Depth',
  SECTION_VIEW: 'Section View',
  CTA_CLICK: 'CTA Click',
  CLICK: 'Click',
  OPEN_GLOBAL_SEARCH: 'Open Global Search',
  OPEN_CONVERSATION: 'Open Conversation',
  ACTOR_VISIT: 'Actor Visit',
  KEYWORDS: 'Keywords',
  BUTTON_CLICK: 'Button Click',
  REMOVE_PORTFOLIO_BUTTON: 'Remove Portfolio Button',
  REMOVE_PORTFOLIO_BUTTON_SIDEPANEL: 'Remove Portfolio Button Sidepanel',
  EXPORT_ACTORS: 'Export actors',
  EXPORT_FINANCIALS: 'Export financials',
  COMMENT: 'Comment',
  LIKE: 'Like',
  PIN: 'Pin',
  CLAIM: 'Claim',
  TOP_BAR_BUTTON: 'Top Bar Button',
  HOMEPAGE_BUTTON: 'Homepage Button',
  ADVANCED_ACTOR_DETAIL_PAGE: 'Advanced Actor Detail Page',
  SIMPLIFIED_ACTOR_DETAIL_PAGE: 'Simplified Actor Detail Page',
  SPOTTING_AREA_SIMPLIFIED_ACTOR_DETAIL_PAGE: 'Spotting Area Simplified Actor Detail Page',
  ONBOARDING_REGISTRATION_COMPLETED_STEPS: 'Onboarding Steps completed',
  ONBOARDING_REGISTRATION_STEPS_SWITCH: 'Onboarding Steps next',
  ONBOARDING_REGISTRATION_STEPS_SKIP: 'Onboarding Steps skip',
  ONBOARDING_STEPS_SOCIAL_LOGIN: 'Onboarding Steps social login',
  ONBOARDING_REGISTRATION_FINISHED_SUCCESSFULLY: 'Onboarding Registration finished successfully',
  APPROVE: 'Approve',
  DENY: 'Deny',
  CREATE_KNOWLEDGE_BASE_RESOURCE: 'Create Knowledge Base Resource',
  EDIT_KNOWLEDGE_BASE_RESOURCE: 'Edit Knowledge Base Resource',
  DELETE_KNOWLEDGE_BASE_RESOURCE: 'Delete Knowledge Base Resource',
  BOOKMARK_POST: 'Bookmark Post',
  UNBOOKMARK_POST: 'Unbookmark Post',
  CREATE_CATEGORY: 'Create Category',
  EDIT_CATEGORY: 'Edit Category',
  DELETE_CATEGORY: 'Delete Category',
  VIEW_CATEGORY_GRID: 'View Category Grid',
  DOWNLOAD_FILE: 'Download File',
  SEARCH_POSTS: 'Search Posts',
  VISIT_RESOURCE: 'Visit Resource',
  TOGGLE: 'Toggle',
  UPLOAD_PHOTO: 'Upload Photo',
  VIEW_ALL: 'View All',
  OPEN_ANNOUNCEMENT: 'Open Announcement',
  VIEW_COMMUNITY: 'View Community',
  VIEW_SPOTTING_AREA: 'View Spotting Area',
  ADD_ACTOR: 'Add Actor',
  ADD_PRODUCT: 'Add Product',
  CREATE_ANNOUNCEMENT: 'Create Announcement',
  CREATE_CHALLENGE: 'Create Challenge',
  LEAVE_COMMUNITY: 'Leave Community',
  EXPAND_TIP: 'Expand Tip',
  COLLAPSE_TIP: 'Collapse Tip',
  TIP_ACTION: 'Tip Action',
  READ_MORE: 'Read More',
  READ_LESS: 'Read Less',
  MODAL_SHOWN: 'Modal Shown',
  DISMISS: 'Dismiss',
  VIEW_MANAGE_SECTION: 'View Manage Section',
  REMOVE_ACTOR_FROM_COMMUNITY: 'Remove Actor From Community',
}

export const MATOMO_EVENT_NAMES = {
  LOGGED_IN: 'Logged In',
  REGISTER: 'Register',
  OPEN_REGISTER_MODAL: 'Open Register Modal',
  GET_IN_TOUCH_ON_LOGIN: 'Get in touch on login',
  SIGN_UP_FOR_EVENT: 'Sign up for event',
  SPOTTING_AREA_CTA_LOGIN: 'Spotting Area CTA: login required',
  SPOTTING_AREA_CTA_UPGRADE: 'Spotting Area CTA: upgrade package',
}
